import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxMediaDetailComponent } from './rx-media-detail.component';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxPipesModule } from '@nrwl/rx-pipes';

@NgModule({
  imports: [CommonModule, RxIconModule, RxPipesModule, RxMediaDetailComponent],
  exports: [RxMediaDetailComponent],
})
export class RxMediaDetailModule {}
